import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";

// Reusable search + filter toolbar for list pages.
export function ListToolbar({ search, onSearch, placeholder = "Search…", filters = [], testid = "list" }) {
  return (
    <div className="flex flex-col sm:flex-row gap-2 sm:items-center" data-testid={`${testid}-toolbar`}>
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          data-testid={`${testid}-search`}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-9"
        />
      </div>
      {filters.map((f) => (
        <Select key={f.key} value={f.value} onValueChange={f.onChange}>
          <SelectTrigger className="w-full sm:w-52" data-testid={`${testid}-filter-${f.key}`}>
            <SelectValue placeholder={f.label} />
          </SelectTrigger>
          <SelectContent className="bg-white">
            {f.options.map((o) => (
              <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ))}
    </div>
  );
}
